export {
  PAGINATION_DEFAULT_ITEMS_PER_PAGE,
  type PaginationChangeEvent,
  PaginationComponent,
} from './pagination.component';
